import { FC } from 'react';
import useTranslation from '../../features/translation/hooks/useTranslation';

enum TranslationsKeys {
  INFO_PANEL = 'infoPanel',
}

export const InfoPanel: FC = () => {
  const t = useTranslation();

  return (
    <div className="fwe-snackbar infopanel">
      <i className="fwe-icon fwe-icon-status-info"></i>
      <span className="technical-info">{t(TranslationsKeys.INFO_PANEL)}</span>
    </div>
  );
};
